import api from "../lib/api";

export const createCauseList = async (payload: any) => {
  return api.post("/api/cause/create-cause", payload);
};

export const editCauseList = async (payload: any) => {
  let {_id, ...rest } = payload;
  return api.post(`/api/cause/edit-cause/${_id}`, rest);
};

export const deleteCauseList = async (_id: string) => {
  return api.post(`/api/cause/delete-cause/${_id}`, );
};

export const getCausesByCnr=async(cnr:string)=>{
  const payload={cnr:cnr}
  return api.post(`/api/cause/get-causes-by-cnr`,payload);
}

export const searchCauseAdvocates = async (keyword: string) => {
  return api.get("/api/cause/search-advocates", {
    params: { keyword },
  });
};
